/*
* <license header>
*/

import React from 'react'
import { Provider, defaultTheme, View } from '@adobe/react-spectrum'
import ErrorBoundary from 'react-error-boundary'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { WebMcpDebug } from './WebMcpDebug'
import { Stats } from './Stats'
import { Editor } from './Editor'

/*
 * Three routes, no application chrome.
 *
 * The editor is the product and owns the whole viewport. The diagnostics page is
 * the only other surface, and it is reached by its deep link rather than by a nav
 * bar. The Adobe scaffold's sidebar and its Home / Your App Actions / About pages
 * were removed: they were sample content, and they made the app look unfinished.
 *
 * Routing stays hash-based (HashRouter) because the App Builder CDN has no SPA
 * history fallback and would serve its 404 document for a real path. That is why
 * the diagnostics link is index.html#/webmcp-debug and not /webmcp-debug.
 *
 * #/stats is the usage view. It is unlinked and behind a key checked by the
 * stats action; not being linked is convenience, the key is the boundary.
 */
function App (props) {
  console.log('runtime object:', props.runtime)
  console.log('ims object:', props.ims)

  // use exc runtime event handlers
  // respond to configuration change events (e.g. user switches org)
  props.runtime.on('configuration', ({ imsOrg, imsToken, locale }) => {
    console.log('configuration change', { imsOrg, imsToken, locale })
  })
  // respond to history change events
  props.runtime.on('history', ({ type, path }) => {
    console.log('history change', { type, path })
  })

  return (
    <ErrorBoundary onError={onError} FallbackComponent={fallbackComponent}>
      <Router>
        <Provider theme={defaultTheme} colorScheme={'light'}>
          {/* Fixed so it is the containing block for the editor's absolute fill. */}
          <View
            position='fixed'
            top='size-0'
            left='size-0'
            width='100vw'
            height='100vh'
            overflow='auto'
            backgroundColor='static-white'
          >
            <Routes>
              <Route path='/' element={<Navigate to='/editor' replace />} />
              <Route path='/editor' element={<Editor />} />
              <Route path='/webmcp-debug' element={<WebMcpDebug />} />
              <Route path='/stats' element={<Stats />} />
              {/* Anything else lands on the editor rather than a blank page. */}
              <Route path='*' element={<Navigate to='/editor' replace />} />
            </Routes>
          </View>
        </Provider>
      </Router>
    </ErrorBoundary>
  )

  // Methods

  // error handler on UI rendering failure
  function onError (e, componentStack) { }

  // component to show if UI fails rendering
  function fallbackComponent ({ componentStack, error }) {
    return (
      <React.Fragment>
        <h1 style={{ textAlign: 'center', marginTop: '20px' }}>
          Something went wrong :(
        </h1>
        <pre>{componentStack + '\n' + error.message}</pre>
      </React.Fragment>
    )
  }
}

export default App
